import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconIcon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"icon"} maskId="square-filled-radius-0-stroke-1-IconIcon"><path fillRule="evenodd" clipRule="evenodd" d="M17 6H21.5C21.7761 6 22 6.22386 22 6.5V20.5C22 20.7761 21.7761 21 21.5 21H2.5C2.22386 21 2 20.7761 2 20.5V6.5C2 6.22386 2.22386 6 2.5 6H7V2H17V6ZM11.5 13H9V14H11.5V16.5H12.5V14H15V13H12.5V10.5H11.5V13ZM8 6H16V3H8V6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconIcon;
